// extracted by mini-css-extract-plugin
export default {"logoFsfbHeader":"HeaderLogo_logoFsfbHeader__ABQue"};